/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';

import Button from 'elements/Button';

export default function Hero() {
  return (
    <section className="jgubg">
      <Fade bottom>
        <div className="w-full lg:w-1/2 xl:pl-12 sm:pr-2">
          <h1 className="text-5xl sm:text-6xl text-3xl text-white mt-8 font-bold leading-tight">
            Linking Innovation to Law
            {' '}
            <br />
          </h1>
          <p className="font-light text-xl text-white-400 leading-relaxed mb-16">
            We foster ethical innovation and knowledge sharing to support the creation of
            revolutionary legal products with a vision is to
            build a community of empowered peers dedicated to transformative ideas.
          </p>

          <Button href="/project" type="link" className="flex w-71 h-18 items-center absolute bottom-10 form px-14 py-5 text-white text-xl rounded-lg shadow-2xl transition duration-200">
            See Our Work
            <svg className="ml-2 w-7 h-7 text-white animate-bounce-x" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Button>
        </div>
      </Fade>

      <Fade bottom>
        <div className="flex pt-5 w-full justify-center items-left order-first md:w-full lg:order-last lg:w-1/2" />
      </Fade>
    </section>
  );
}
